<script setup lang="ts">
/**
 * Button primitive. Variants: primary (once per view), subtle, ghost.
 * Use `icon` for square icon-only buttons (always pass an aria-label).
 */
withDefaults(
  defineProps<{
    variant?: 'primary' | 'subtle' | 'ghost' | 'danger';
    size?: 'sm' | 'md';
    icon?: boolean;
    block?: boolean;
    /** Shows a busy state and blocks clicks while an action runs. */
    loading?: boolean;
    type?: 'button' | 'submit' | 'reset';
  }>(),
  { variant: 'subtle', size: 'md', icon: false, block: false, loading: false, type: 'button' },
);
</script>

<template>
  <button
    :type="type"
    class="button"
    :class="[
      `button--${variant}`,
      { 'button--sm': size === 'sm', 'button--icon': icon, 'button--block': block },
    ]"
    :disabled="loading || undefined"
    :aria-busy="loading || undefined"
  >
    <slot />
  </button>
</template>
